import { useEmergencyContactStep } from "./useEmergencyContactStep";
import { useInformationStep } from "./useInformationStep";
import { useParentInformationFatherStep } from "./useParentInformationFatherStep";
import { useParentInformationMotherStep } from "./useParentInformationMotherStep";
// import { useProxyContactStep } from "./useProxyContactStep";

export const useStudentDetailsParamsSteps = () => {
    const informationStep = useInformationStep();
    const parentInformationFatherStep = useParentInformationFatherStep();
    const parentInformationMotherStep = useParentInformationMotherStep();
    const emergencyContactStep = useEmergencyContactStep();
    // const proxyContactStep = useProxyContactStep();

    return [
        informationStep,
        parentInformationFatherStep,
        parentInformationMotherStep,
        emergencyContactStep,
        // proxyContactStep,
    ];
};
